import { SyncUserParams, SyncUserResponse } from '@app/models/saga';
import { apiLinks, httpClient } from '@app/utils';

const syncUser = async (data: SyncUserParams): Promise<SyncUserResponse> => {
  const response = await httpClient.post({
    url: apiLinks.admin.saga.syncUser,
    data,
  });

  return response.data as SyncUserResponse;
};

const sagaServices = { syncUser };

export default sagaServices;
